import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-01/lesson-03/task-02";

const task: Slide = {
  title: "In air, speed of sound increases if ...",
  description: "Select the correct answer(s):",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
